export interface LocalScoreEntry {
  name: string;
  score: number;
  grade: string;
  completedAt: string;
}

const SCORES_KEY = 'glitch-pursuit.local-scores.v1';
const NAME_KEY = 'glitch-pursuit.agent-name.v1';
/** Small local-only persistence layer; deliberately contains no account or network data. */
export class LocalProfile {
  get agentName(): string {
    try {
      return this.cleanName(localStorage.getItem(NAME_KEY) ?? 'ACE');
    } catch {
      return 'ACE';
    }
  }

  scores(): LocalScoreEntry[] {
    try {
      const parsed = JSON.parse(localStorage.getItem(SCORES_KEY) ?? '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter((entry): entry is LocalScoreEntry =>
          typeof entry?.name === 'string' && typeof entry?.score === 'number' && typeof entry?.grade === 'string')
        .sort((a, b) => b.score - a.score || a.completedAt.localeCompare(b.completedAt))
        .slice(0, 10);
    } catch {
      return [];
    }
  }

  bank(name: string, score: number, grade: string): LocalScoreEntry[] {
    const cleanName = this.cleanName(name);
    const next = [
      ...this.scores(),
      { name: cleanName, score: Math.max(0, Math.floor(score)), grade, completedAt: new Date().toISOString() },
    ].sort((a, b) => b.score - a.score || a.completedAt.localeCompare(b.completedAt)).slice(0, 10);
    try {
      localStorage.setItem(NAME_KEY, cleanName);
      localStorage.setItem(SCORES_KEY, JSON.stringify(next));
    } catch {
      // Storage can be disabled in private contexts; the current result still renders.
    }
    return next;
  }

  private cleanName(value: string): string {
    return value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3) || 'ACE';
  }
}
